export class Tienda {
  categoria: number;
  createdAt: Date;
  descripcion: string;
  estado: number;
  imagen: string;
  imagenes: Array<string>;
  local: Array<number>;
  logo: string;
  nombre: string;
  estadoContenido: string;
  estadoPuntoInteres: string;
  numeroPiso: number;
  orden: number;
  piiDescripcionDescuento: string;
  pinDescuento: string;
  piso: number;
  prioridad: number;
  puntoInteres: number;
  subcategorias: Array<number>;
  tags: Array<string>;
  telefono: string;
  updatedAt: Date;
  url: string;

  constructor(item: any) {
    this.categoria               = item.categoria;
    this.createdAt               = item.createdAt;
    this.descripcion             = item.descripcion;
    this.estadoPuntoInteres      = item.estado_punto_interes;
    this.imagen                  = item.imagen_plano_punto_interes;
    this.imagenes                = item.imagenes;
    this.local                   = item.local;
    this.logo                    = item.logo;
    this.nombre                  = item.nombre;
    this.estadoContenido         = item.nombre_estado_contenido;
    this.estado                  = item.nombre_estado_punto_interes;
    this.numeroPiso              = item.numero_piso;
    this.orden                   = item.orden;
    this.piiDescripcionDescuento = item.piiDescripcionDescuento;
    this.pinDescuento            = item.pinDescuento;
    this.piso                    = item.piso;
    this.prioridad               = item.prioridad;
    this.puntoInteres            = item.punto_interes;
    this.subcategorias           = item.sub_categoria.map((id) => Number(id));
    this.tags                    = item.tags;
    this.telefono                = item.telefono_punto_interes;
    this.updatedAt               = item.updatedAt;
    this.url                     = item.url_punto_interes;
  }
}
